import { Map } from 'immutable';

import {
  DELETE_INTRUSION_SENSOR_CONFIGURATION,
  RECEIVE_INTRUSION_SENSOR_CONFIGURATIONS,
} from '@sophocles/entities/IntrusionSensorConfiguration/intrusionSensorConfigurationActions';

export function intrusionSensorConfigurationReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_INTRUSION_SENSOR_CONFIGURATIONS:
      return state.merge(action.intrusionSensorConfigurations);
    case DELETE_INTRUSION_SENSOR_CONFIGURATION:
      return state.delete(action.intrusionSensorConfiguration.toString());
    default:
      return state;
  }
}
